import { C as T, d as b } from "./component-CAYPdBLR.js";
import { B as P } from "./cache-B3iI9tCV.js";
import { m as v, b as C } from "./section-renderer-O9dH0e4S.js";
import "./morph-BgZiyH00.js";
class c {
  static HOST_ID = "instant-router-loading-indicator";
  static BAR_ID = "instant-router-loading-indicator-bar";
  static THROTTLE_DELAY_MS = 180;
  static FADE_OUT_DELAY_MS = 220;
  static RESET_DELAY_MS = 200;
  static PROGRESS_INTERVAL_MS = 180;
  static JUMP_START_PROGRESS = 0.1;
  static PROGRESS_CAP = 0.85;
  static PROGRESS_STEP_MIN = 0.01;
  static PROGRESS_STEP_FACTOR = 0.08;
  #t = null;
  #n = null;
  #e = 0;
  #i;
  #c;
  #r = 0;
  #s = !1;
  ensure() {
    if (this.#t && this.#n) return;
    const t = document.getElementById(c.HOST_ID);
    if (t instanceof HTMLElement) {
      this.#t = t;
      const o = t.querySelector(`#${c.BAR_ID}`);
      if (((this.#n = o instanceof HTMLElement ? o : null), this.#n)) return;
    }
    const e = document.createElement("div");
    ((e.id = c.HOST_ID), e.setAttribute("aria-hidden", "true"));
    const i = document.createElement("div");
    ((i.id = c.BAR_ID),
      e.append(i),
      document.body.append(e),
      (this.#t = e),
      (this.#n = i),
      this.#o(0));
  }
  start() {
    (this.ensure(),
      (this.#r += 1),
      !this.#s &&
        (clearTimeout(this.#c),
        (this.#c = window.setTimeout(() => {
          this.#r <= 0 ||
            ((this.#s = !0),
            this.#t?.classList.add("is-active"),
            this.#o(Math.max(this.#e, c.JUMP_START_PROGRESS)),
            this.#l());
        }, c.THROTTLE_DELAY_MS))));
  }
  finish() {
    if ((this.ensure(), (this.#r = Math.max(0, this.#r - 1)), !(this.#r > 0))) {
      if (!this.#s) {
        (clearTimeout(this.#c), this.#a(), this.#o(0));
        return;
      }
      (this.#a(),
        this.#o(1),
        window.setTimeout(() => {
          (this.#t?.classList.remove("is-active"),
            (this.#s = !1),
            window.setTimeout(() => this.#o(0), c.RESET_DELAY_MS));
        }, c.FADE_OUT_DELAY_MS));
    }
  }
  error() {
    this.finish();
  }
  #l() {
    (this.#a(),
      (this.#i = window.setInterval(() => {
        const t = c.PROGRESS_CAP;
        if (this.#e >= t) return;
        const e = t - this.#e,
          i = Math.max(c.PROGRESS_STEP_MIN, e * c.PROGRESS_STEP_FACTOR);
        this.#o(Math.min(t, this.#e + i));
      }, c.PROGRESS_INTERVAL_MS)));
  }
  #a() {
    this.#i !== void 0 && (clearInterval(this.#i), (this.#i = void 0));
  }
  #o(t) {
    ((this.#e = Math.max(0, Math.min(1, t))),
      this.#t && this.#t.style.setProperty("--instant-router-progress", String(this.#e)));
  }
}
let w;
function E() {
  return (w || (w = new c()), w);
}
function R(n) {
  const t = new URL(n, window.location.origin),
    e = k(t.pathname),
    i = M();
  if (!e) return !1;
  if (!i) return !0;
  if (i === e) return !1;
  const o = (r) => r === "product" || r === "collection";
  return o(i) && o(e);
}
function M() {
  const n = document.getElementById("main-content");
  return n
    ? n.classList.contains("template-product")
      ? "product"
      : n.classList.contains("template-collection")
        ? "collection"
        : null
    : null;
}
function k(n) {
  return n.includes("/products/") ? "product" : n.includes("/collections/") ? "collection" : null;
}
function _() {
  if (window.location.pathname.includes("/products/")) {
    const n = document.querySelector('[data-section-type="product"]');
    if (n && n.dataset.sectionId) return n.dataset.sectionId;
  }
  return "main";
}
function F() {
  if (window.location.pathname.includes("/collections/")) {
    const n = document.querySelector('[data-section-type="collection"]');
    if (n && n.dataset.sectionId) return n.dataset.sectionId;
  }
  return "main";
}
function g(n, t) {
  const e = new URL(n, window.location.origin),
    i = e.pathname.includes("/products/"),
    o = e.pathname.includes("/collections/"),
    r = window.location.pathname.includes("/products/"),
    s = window.location.pathname.includes("/collections/");
  if (i && r) {
    const a = t || _();
    return (a && e.searchParams.set("section_id", a), e.toString());
  }
  if (o && s) {
    const a = t || F();
    return (a && e.searchParams.set("section_id", a), e.toString());
  }
  return e.toString();
}
function I(n) {
  try {
    return (
      new DOMParser()
        .parseFromString(n, "text/html")
        .querySelector(".carousel-slide img, .product-images img, [data-product-image]")?.src ||
      null
    );
  } catch {
    return null;
  }
}
function q(n, t) {
  if (!n) return;
  const e = new Image();
  e.src = n;
}
const l = {
    BEFORE_NAVIGATE: "beforeNavigate",
    AFTER_SWAP: "afterSwap",
    AFTER_UPGRADE: "afterUpgrade",
  },
  m = { [l.BEFORE_NAVIGATE]: [], [l.AFTER_SWAP]: [], [l.AFTER_UPGRADE]: [] };
function f(n, t) {
  if (!m[n]) throw new Error(`Unknown hook phase: ${n}. Use: ${Object.keys(m).join(", ")}`);
  m[n].push(t);
}
async function h(n, t) {
  const e = m[n] || [];
  for (const i of e)
    try {
      await i(t);
    } catch (o) {
      console.error(`InstantRouter hook error in ${n}:`, o);
    }
}
f(l.AFTER_SWAP, async ({ container: n }) => {
  if (!n) return;
  const e = new URL(window.location.href).searchParams.get("variant");
  if (!e) return;
  const i = n.querySelector("#variant-id-input"),
    o = n.querySelector("variant-selector");
  if (!o) {
    i && (i.value = "");
    return;
  }
  await customElements.whenDefined("variant-selector");
  const r = o.querySelector(`input[data-variant-id="${e}"]`);
  if (r)
    ((r.checked = !0), i && (i.value = e), r.dispatchEvent(new Event("change", { bubbles: !0 })));
  else {
    const s = o.querySelector('input[type="radio"]:checked');
    s && i ? (i.value = s.dataset.variantId || "") : i && (i.value = "");
  }
});
f(l.AFTER_SWAP, async ({ url: n }) => {
  !n ||
    !n.includes("/products/") ||
    (window.jdgm?.widget && window.jdgm.widget.load(),
    window.SPR && (window.SPR.initDomEls(), window.SPR.loadBadges()),
    window.yotpo?.refreshWidgets && window.yotpo.refreshWidgets(),
    window.SwymCallbacks && window.SwymCallbacks.forEach((t) => t()),
    window.kachingSubscriptionsInit && window.kachingSubscriptionsInit());
});
f(l.AFTER_SWAP, async ({ container: n }) => {
  if (!n) return;
  const e = (n.closest(".shopify-section") || n).id?.replace("shopify-section-", "") || "";
  document.dispatchEvent(new CustomEvent("shopify:section:load", { detail: { sectionId: e } }));
});
f(l.AFTER_UPGRADE, async ({ container: n }) => {
  if (!n) return;
  n.querySelectorAll("*").forEach((e) => {
    e.tagName.includes("-") && window.customElements?.upgrade && window.customElements.upgrade(e);
  });
});
typeof window < "u" && (window.InstantRouterAPI = { registerHook: f, LifecyclePhases: l });
function L(n) {
  if (!n) return;
  n.querySelectorAll("*").forEach((e) => {
    e.tagName.includes("-") && window.customElements?.upgrade && window.customElements.upgrade(e);
  });
}
const O = ["product", "collection"];
function D() {
  const n = document.getElementById("main-content");
  return n ? O.some((t) => n.classList.contains(`template-${t}`)) : !1;
}
function x(n) {
  const t = document.getElementById("main-content");
  if (!t) return [];
  const e = t.querySelectorAll(".shopify-section");
  return Array.from(e)
    .map((o) => {
      const r = o.id.match(/^shopify-section-(.+)$/);
      return r ? r[1] : null;
    })
    .filter((o) => o && o !== n);
}
async function H(n, t, e, i) {
  if (!t) return;
  const o = x(t);
  if (o.length !== 0)
    try {
      await Promise.all(
        o.map(async (r) => {
          try {
            const s = await e.fetchSection(n, r, { signal: i });
            await v(r, s);
            const a = document.getElementById(C(r));
            (a && L(a),
              document.dispatchEvent(
                new CustomEvent("shopify:section:load", { detail: { sectionId: r } })
              ));
          } catch (s) {
            if (s.name === "AbortError") return;
            console.warn(`Error updating section ${r}:`, s);
          }
        })
      );
    } catch (r) {
      r.name !== "AbortError" && console.warn("Error updating other sections:", r);
    }
}
function y(n) {
  const t = n.querySelector("title")?.textContent;
  (t && (document.title = t),
    n.documentElement?.lang && (document.documentElement.lang = n.documentElement.lang),
    n.documentElement?.dir && (document.documentElement.dir = n.documentElement.dir),
    S(n, 'meta[name="description"]', "name", "description"),
    S(n, 'meta[name="robots"]', "name", "robots"));
  const e = n.querySelector('link[rel="canonical"]'),
    i = document.querySelector('link[rel="canonical"]');
  (e instanceof HTMLLinkElement &&
    (i instanceof HTMLLinkElement ? (i.href = e.href) : document.head.append(e.cloneNode(!0))),
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((r) => r.remove()),
    n.querySelectorAll('link[rel="alternate"][hreflang]').forEach((r) => {
      document.head.append(r.cloneNode(!0));
    }),
    document
      .querySelectorAll('meta[property^="og:"], meta[name^="twitter:"]')
      .forEach((r) => r.remove()),
    n.querySelectorAll('meta[property^="og:"], meta[name^="twitter:"]').forEach((r) => {
      document.head.append(r.cloneNode(!0));
    }),
    document
      .querySelectorAll('script[type="application/ld+json"][data-theme-jsonld]')
      .forEach((r) => r.remove()),
    n.querySelectorAll('script[type="application/ld+json"][data-theme-jsonld]').forEach((r) => {
      document.head.append(r.cloneNode(!0));
    }));
}
function S(n, t, e, i) {
  const o = n.querySelector(t),
    r = document.querySelector(`meta[${e}="${i}"]`);
  o instanceof HTMLMetaElement
    ? r instanceof HTMLMetaElement
      ? (r.content = o.content)
      : document.head.append(o.cloneNode(!0))
    : r && r.remove();
}
class U {
  constructor(t) {
    this.cache = t;
  }
  async fetchSection(t, e, { signal: i, useCache: o = !0 } = {}) {
    if (o) {
      const p = this.cache.get(t);
      if (p?.section) return p.section;
    }
    const r = g(t, e),
      s = await fetch(r, { signal: i });
    if (!s.ok) throw new Error(`HTTP ${s.status}: ${s.statusText}`);
    const a = await s.text(),
      d = this.cache.get(t);
    return (d ? this.cache.set(t, { ...d, section: a }) : this.cache.set(t, { section: a }), a);
  }
  async fetchFullPage(t, { signal: e, useCache: i = !0 } = {}) {
    if (i) {
      const a = this.cache.get(t);
      if (a?.page) return a.page;
    }
    const o = await fetch(t, { signal: e });
    if (!o.ok) throw new Error(`HTTP ${o.status}: ${o.statusText}`);
    const r = await o.text(),
      s = this.cache.get(t);
    return (s ? this.cache.set(t, { ...s, page: r }) : this.cache.set(t, { page: r }), r);
  }
}
function A(n) {
  const t = n.querySelectorAll("script");
  if (t.length !== 0)
    for (const e of t) {
      const i = document.createElement("script");
      for (const o of e.attributes) i.setAttribute(o.name, o.value);
      ((i.textContent = e.textContent), e.replaceWith(i));
    }
}
async function N(n, t) {
  const i = new DOMParser().parseFromString(t, "text/html");
  let o = i.querySelector("instant-router > [ref='container']");
  if (!o) {
    const s = i.querySelectorAll("[ref='container']");
    for (const a of s)
      if (a.tagName.toLowerCase() === "section") {
        o = a;
        break;
      }
    !o && s.length > 0 && (o = s[0]);
  }
  if (!o) throw new Error("Container element not found in section response");
  const r = o;
  return (
    r.setAttribute("ref", "container"),
    n.replaceWith(r),
    A(r),
    await new Promise((s) => {
      requestAnimationFrame(s);
    }),
    r
  );
}
async function G(n) {
  const e = new DOMParser().parseFromString(n, "text/html"),
    i = e.getElementById("main-content"),
    o = document.getElementById("main-content");
  if (!i) throw new Error("#main-content not found in full page response");
  if (!o) throw new Error("#main-content not found in current document");
  return (
    y(e),
    e.body?.className && (document.body.className = e.body.className),
    o.replaceWith(i),
    A(i),
    await new Promise((r) => {
      requestAnimationFrame(r);
    }),
    i
  );
}
class u extends T {
  requiredRefs = ["container"];
  static cache = new P({ maxSize: 50, ttlMs: 3e5 });
  #t;
  #n;
  #e;
  fetcher;
  connectedCallback() {
    if ((super.connectedCallback(), window.Shopify?.designMode)) {
      console.debug("InstantRouter: Disabled in theme editor");
      return;
    }
    (E().ensure(),
      (this.fetcher = new U(u.cache)),
      document.addEventListener(
        "liquid-ajax-cart:request-end",
        (t) => {
          const { requestType: e } = t.detail;
          (e === "change" || e === "add" || e === "update") &&
            (u.cache.clear(), console.debug("InstantRouter: Cache cleared after cart mutation"));
        },
        { signal: this.signal }
      ),
      (this.#e = this.#c.bind(this)),
      document.addEventListener("click", this.#e, { capture: !0, signal: this.signal }),
      this.addEventListener("mouseover", this.#i, { signal: this.signal }),
      this.addEventListener("focusin", this.#i, { signal: this.signal }),
      this.addEventListener("touchstart", this.#i, { passive: !0, signal: this.signal }),
      (this.#n = this.#r.bind(this)),
      window.addEventListener("popstate", this.#n, { signal: this.signal }));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(),
      this.#n && window.removeEventListener("popstate", this.#n),
      this.#e && document.removeEventListener("click", this.#e, { capture: !0 }),
      this.#t?.abort());
  }
  #i = (t) => {
    const e = t.target.closest("a[data-instant-link]");
    if (!e) return;
    const i = e.href;
    !i || u.cache.has(i) || this.#s(i);
  };
  #c = (t) => {
    const e = t.target.closest("a[data-instant-link]");
    if (!e || t.metaKey || t.ctrlKey || t.shiftKey) return;
    const i = e.closest("carousel-embla, [data-carousel]");
    if (i) {
      const o = i.embla || i.querySelector("carousel-embla")?.embla;
      if (o?.clickAllowed && !o.clickAllowed()) return;
    }
    (t.preventDefault(), this.#l(e.href));
  };
  #r = () => {
    this.#a(window.location.href, { pushState: !1, scrollUp: !1 });
  };
  async #s(t) {
    if (u.cache.has(t)) return;
    const e = g(t, this.dataset.sectionId);
    try {
      const i = await fetch(e, { signal: this.signal });
      if (i.ok) {
        const o = await i.text(),
          r = e.includes("section_id=") ? { section: o } : { page: o };
        u.cache.set(t, r);
        const s = I(o);
        s && q(s);
      }
    } catch {}
  }
  async #l(t) {
    await this.#a(t, { pushState: !0, scrollUp: !0 });
  }
  async #a(t, { pushState: e, scrollUp: i }) {
    const o = E();
    o.start();
    try {
      (await h(l.BEFORE_NAVIGATE, { url: t, currentUrl: window.location.href }),
        e && window.history.pushState({}, "", t),
        R(t) ? await this.#u(t, i) : await this.#o(t, i));
    } finally {
      o.finish();
    }
  }
  async #o(t, e) {
    (this.#t?.abort(), (this.#t = new AbortController()));
    const i = this.#d(t);
    let o;
    try {
      o = await this.fetcher.fetchSection(t, this.dataset.sectionId, { signal: this.#t.signal });
    } catch (a) {
      if (a.name === "AbortError") return;
      (console.error("Product router fetch error:", a),
        window.history.replaceState({}, "", t),
        (window.location.href = t));
      return;
    }
    let r = document.querySelector("instant-router > [ref='container']");
    if (!r) {
      const a = document.querySelectorAll("instant-router [ref='container']");
      for (const d of a)
        if (d.tagName.toLowerCase() === "section") {
          r = d;
          break;
        }
      !r && a.length > 0 && (r = a[0]);
    }
    if (!r) {
      window.location.href = t;
      return;
    }
    let s;
    try {
      s = await N(r, o);
    } catch (a) {
      (console.error("Renderer error:", a),
        window.history.replaceState({}, "", t),
        (window.location.href = t));
      return;
    }
    ((this.refs.container = s),
      (this.refs = { container: s }),
      await h(l.AFTER_SWAP, { url: t, container: s }),
      await h(l.AFTER_UPGRADE, { container: s }),
      await i,
      s &&
        (s.setAttribute("tabindex", "-1"),
        s.focus({ preventScroll: !0 }),
        s.removeAttribute("tabindex")),
      document.dispatchEvent(
        new CustomEvent("instant-router:content-swapped", {
          detail: { url: t, container: s, isFullPage: !1, timestamp: Date.now() },
          bubbles: !0,
        })
      ),
      e && window.scrollTo({ top: 0, behavior: "smooth" }),
      D() && (await H(t, this.dataset.sectionId, this.fetcher, this.#t?.signal)),
      document.dispatchEvent(new CustomEvent("page:switched", { detail: { url: t } })));
  }
  async #u(t, e) {
    (this.#t?.abort(), (this.#t = new AbortController()));
    let i;
    try {
      i = await this.fetcher.fetchFullPage(t, { signal: this.#t.signal });
    } catch (a) {
      if (a.name === "AbortError") return;
      (console.error("Instant Router full-page fetch error:", a), (window.location.href = t));
      return;
    }
    let o;
    try {
      o = await G(i);
    } catch (a) {
      (console.error("Renderer error:", a), (window.location.href = t));
      return;
    }
    const r = document.querySelector("instant-router");
    if (r) {
      const a = r.querySelector("[ref='container']");
      a instanceof HTMLElement && ((this.refs.container = a), (this.refs = { container: a }));
    }
    (await h(l.AFTER_SWAP, { url: t, container: o }), await h(l.AFTER_UPGRADE, { container: o }));
    const s = this.refs.container || o;
    (s instanceof HTMLElement &&
      (s.setAttribute("tabindex", "-1"),
      s.focus({ preventScroll: !0 }),
      s.removeAttribute("tabindex")),
      document.dispatchEvent(
        new CustomEvent("instant-router:content-swapped", {
          detail: { url: t, container: this.refs.container, isFullPage: !0, timestamp: Date.now() },
          bubbles: !0,
        })
      ),
      e && window.scrollTo({ top: 0, behavior: "smooth" }),
      document.dispatchEvent(new CustomEvent("page:switched", { detail: { url: t } })));
  }
  async #d(t) {
    try {
      const e = await this.fetcher.fetchFullPage(t, { signal: this.#t?.signal }),
        i = new DOMParser().parseFromString(e, "text/html");
      y(i);
    } catch (e) {
      if (e?.name === "AbortError") return;
    }
  }
}
b("instant-router", u);
